import { useMemo } from 'react';

import { EventType } from '@/analytics/types';
import type { LandingPageProfile } from '@/app/components/LandingPage/LandingPageProfileCards/LandingPageProfileCard';

const BLOG_HREF = 'https://ouraring.com/blog';

const goToMedicalAdvisor = (localePartialUrl: string, path: string) => {
  void window.ouraAnalytics.track(EventType.CTAClicked, {
    cta: 'read_more',
    location: 'science and research',
    action: 'goes to blog',
    path,
  });

  window.open(`${BLOG_HREF}${localePartialUrl}${path}`, '_blank');
};

export const useMedicalAdvisors = (
  localePartialUrl: string,
): LandingPageProfile[] => {
  return useMemo(
    () => [
      {
        description: 'science_and_research_rebecca_robbins',
        name: 'Dr. Rebecca Robbins, Phd',
        image: 'blue-sky/science-and-research/rebecca-robbins',
        imageMobile: 'blue-sky/science-and-research/rebecca-robbins-mobile',
        imageAlt: 'science_and_research_medical_advisor_female_alt',
        onLinkClick: () =>
          goToMedicalAdvisor(localePartialUrl, 'oura-qa-rebecca-robbins-phd/'),
      },
      {
        description: 'science_and_research_jake_deutsch',
        name: 'Dr. Jake Deutsch, MD',
        image: 'blue-sky/science-and-research/jake-deutsch',
        imageMobile: 'blue-sky/science-and-research/jake-deutsch-mobile',
        imageAlt: 'science_and_research_medical_advisor_male_alt',
        onLinkClick: () =>
          goToMedicalAdvisor(localePartialUrl, 'the-oura-qa-jake-deutsch/'),
      },
      {
        description: 'science_and_research_elissa_epel',
        name: 'Dr. Elissa Epel, Phd',
        image: 'blue-sky/science-and-research/elissa-epel',
        imageMobile: 'blue-sky/science-and-research/elissa-epel-mobile',
        imageAlt: 'science_and_research_medical_advisor_female_alt',
        onLinkClick: () =>
          goToMedicalAdvisor(localePartialUrl, 'the-oura-qa-elissa-epel-phd/'),
      },
      {
        description: 'science_and_research_eleni_jaswa',
        name: 'Dr. Eleni Jaswa, MD, MSc, FACOG',
        image: 'blue-sky/science-and-research/eleni-jaswa',
        imageMobile: 'blue-sky/science-and-research/eleni-jaswa-mobile',
        imageAlt: 'science_and_research_medical_advisor_female_alt',
        onLinkClick: () =>
          goToMedicalAdvisor(localePartialUrl, 'oura-qa-dr-eleni-jaswa/'),
      },
      {
        description: 'science_and_research_jagmeet_singh',
        name: 'Jagmeet P. Singh MD ScM DPhil',
        image: 'blue-sky/science-and-research/jagmeet-singh',
        imageMobile: 'blue-sky/science-and-research/jagmeet-singh-mobile',
        imageAlt: 'science_and_research_medical_advisor_male_alt',
      },
      {
        description: 'science_and_research_michael_chee',
        name: 'Michael WL Chee, MBBS, FRCP (Edin)',
        image: 'blue-sky/science-and-research/michael-chee',
        imageMobile: 'blue-sky/science-and-research/michael-chee-mobile',
        imageAlt: 'science_and_research_medical_advisor_male_alt',
        onLinkClick: () =>
          goToMedicalAdvisor(localePartialUrl, 'oura-qa-dr-michael-wl-chee/'),
      },
    ],
    [localePartialUrl],
  );
};
